import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Grid } from '@material-ui/core';

import {
  ThunkGetMessagingConfiguration,
  ThunkGetMessagingChannel,
  ThunkGetMessagingChannelCrmInfo,
} from '@store/slices/messaging/thunks';

import ChannelDetails from './components/ChannelDetails';
import History from './components/History';
import Loading from '../../common/Loading/Loading';
import CrmSpecificInfo from './components/CrmSpecificInfo';

import useStyles from './styles';

const MessagingChannel = React.memo(({ match }) => {
  const [loading, setLoading] = useState(true);
  const [hideInfo, setHideInfo] = useState(false);

  const classes = useStyles({ hideInfo });
  const dispatch = useDispatch();

  const handleInfoHide = useCallback((state = true) => {
    setHideInfo(state);
  }, []);

  const onMount = useCallback(() => {
    setLoading(true);
    Promise.all([
      dispatch(
        ThunkGetMessagingConfiguration(match.params.configurationId),
      ).unwrap(),
      dispatch(ThunkGetMessagingChannel(match.params.channelId)).unwrap(),
      dispatch(
        ThunkGetMessagingChannelCrmInfo(match.params.channelId),
      ).unwrap(),
    ]).finally(() => {
      setLoading(false);
    });
  }, [dispatch, match.params.channelId, match.params.configurationId]);

  useEffect(() => {
    onMount();
  }, [onMount]);

  if (loading) return <Loading />;

  return (
    <div className={classes.wrapper}>
      <Grid container>
        <Grid md={6} xs={12} item>
          {!hideInfo && (
            <div>
              <ChannelDetails />
              <CrmSpecificInfo />
            </div>
          )}
        </Grid>
        <Grid item md={!hideInfo ? 6 : 12} xs={12}>
          <History
            channelId={match.params.channelId}
            handleInfoHide={handleInfoHide}
            hideInfo={hideInfo}
          />
        </Grid>
      </Grid>
    </div>
  );
});

MessagingChannel.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      channelId: PropTypes.string,
      configurationId: PropTypes.string,
    }),
  }),
};

export default MessagingChannel;
